import { getProductPackageQuery } from '@/modules/productPackages/lib/productQuery'

export const hasRequiredPaymentData = (_, __, next) => {
  if (!getProductPackageQuery()) {
    return next({ name: 'product-packages', replace: true })
  }

  return next()
}
